import Marquee from "react-fast-marquee";
import { Sparkle } from "@phosphor-icons/react";

const KEYWORDS = [
  "Accounting", "GST Returns", "Income Tax Return (ITR)", "TDS Compliance",
  "Bookkeeping", "Financial Reporting", "Tally Prime", "QuickBooks Online",
  "GST Registration", "Tax Planning", "Balance Sheet", "MIS Reports",
];

export const Ribbon = () => (
  <div data-testid="marquee-ribbon" className="bg-navy py-4 border-y border-white/10">
    <Marquee speed={40} gradient={false} pauseOnHover>
      {KEYWORDS.map((k) => (
        <span key={k} className="mx-8 inline-flex items-center gap-3 font-display text-lg md:text-xl text-white/90">
          {k}
          <Sparkle size={18} weight="fill" className="text-gold" />
        </span>
      ))}
    </Marquee>
  </div>
);
